var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentlyClippedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Recently_Clipped-Icon",
    transform: "translate(-401)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 40,
    height: 40,
    rx: 8,
    transform: "translate(401)",
    fill: "#211f21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1822",
    "data-name": "Group 1822",
    transform: "translate(410.75 9.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M6.005,5.74a1.9,1.9,0,0,1-1.346.866c-.312.044-.621.092-.93.144A1.788,1.788,0,0,0,2.25,8.529v6.914A1.846,1.846,0,0,0,4.1,17.288H16.4a1.846,1.846,0,0,0,1.846-1.846V8.529a1.789,1.789,0,0,0-1.479-1.78q-.464-.077-.93-.144A1.9,1.9,0,0,1,14.5,5.74l-.674-1.08A1.8,1.8,0,0,0,12.4,3.807a40.019,40.019,0,0,0-4.293,0,1.8,1.8,0,0,0-1.424.853L6.005,5.74Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M14.885,11.942A3.692,3.692,0,1,1,11.192,8.25a3.692,3.692,0,0,1,3.692,3.692ZM16.731,10.1h.007V10.1h-.007Z",
    transform: "translate(-0.942 -0.808)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentlyClippedIcon);
export default __webpack_public_path__ + "static/media/Recently-Clipped-Icon.c387eb151cae2f37d08343bc7f277210.svg";
export { ForwardRef as ReactComponent };